import React from 'react';
import { CimmplePayDocLayout } from './CimmplePayDocLayout';
import { goLiveChecklistMarkdown } from '../../../content/cimmplepay/go-live-checklist.md';

const GoLiveChecklist: React.FC = () => {
  return (
    <CimmplePayDocLayout
      seoTitle="Go-Live Checklist | CimmplePay Docs"
      seoDescription="A production readiness checklist for CimmplePay ERP integrations: security, auth, data mapping, functional validation, operations, and documentation."
      markdown={goLiveChecklistMarkdown}
    />
  );
};

export default GoLiveChecklist;
